import { getStreamParams } from '@wix/da-shared-react/pkg/Stream/base/selectors';
import { MessageLogStreamParams } from '../../types/groupsBackroom';
import { GROUP_MESSAGELOG_IDS_STREAM } from '../streams';

const messageLogParamDefaults: MessageLogStreamParams = {
  sortBy: 'newest',
};

export function getMessageLogParams(state): MessageLogStreamParams {
  return {
    ...messageLogParamDefaults,
    ...(getStreamParams(state, GROUP_MESSAGELOG_IDS_STREAM) ?? {}),
  };
}
